module.exports = __webpack_public_path__ + "3fec01c35e3274d441c9ce069d01ebe5.svg";